// @flow @format
import Header from '../components/Header';
import {logout} from '../../../reducers/session';
import {connect} from 'react-redux';

import type {State} from '../../../reducers';

const mapStateToProps = (state: State) => ({
	user: state.session.user,
});

const mapDispatchToProps = {
	logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/routes/Explorer/containers/HeaderContainer.js